import { defineStyle } from '@chakra-ui/react';

export const AdmonitionHeaderStyles = defineStyle({
  display: 'flex',
  alignItems: 'center',
  gap: 2,
  alignSelf: 'stretch',
  mb: 2,
});
